const IBM_WITHOUT_COMPANION = new Set([
  "192056",
  "305751",
  "226027",
  "395493",
  "338487",
  "343196",
  "166361",
  "226456",
  "253997",
  "372814",
  "374464",
  "446641",
  "166010",
  "450466",
]);

export function isCompanionRestricted(ibm) {
  const normalizedIbm = String(ibm ?? "").replace(/\D/g, "");
  return IBM_WITHOUT_COMPANION.has(normalizedIbm);
}
